module.exports = function getResource(label) {
    const resources = {
        endingIn: 'ending in',
        cardNumber: 'Card number',
        mm: 'MM',
        yy: 'YY',
        cvc: 'CVV/CVC',
        moreInfoPopover: 'More info about CVV',
        firstName: 'First name',
        lastName: 'Last name',
        billingAddress: 'Billing Address',
        useMyAddressRadio: 'Use my shipping address',
        useDiffAddressRadio: 'Use a different address',
        saveCardCheckboxText: 'Save this card for future purchases',
        makeDefaultCheckboxText: 'Set as my default card',
        editCardTitle: 'Edit credit card or debit card',
        addNewCardTitle: 'Add new credit or debit card',
        cancelButton: 'Cancel',
        saveContinueButton: 'Save & Continue',
        debitCardDisclaimer: 'Visa and Mastercard debit cards only'
    };

    return resources[label];
};
